import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { IconDepositorH, IconBeneficiaryH } from 'src/components/Svg/Icons';

export const roleOptions = [
  {
    value: EscrowPartyTypeEnum.Depositor,
    title: 'Depositor',
    description: 'The party providing the application to its clients.',
    icon: IconDepositorH,
  },
  {
    value: EscrowPartyTypeEnum.Beneficiary,
    title: 'Beneficiary',
    description: 'The party that uses the application as part of its arrangement with a service provider.',
    icon: IconBeneficiaryH,
  },
];

export const roleOptionsDict = roleOptions.reduce(
  (acc, option) => {
    acc[option.value] = option;
    return acc;
  },
  {} as Record<EscrowPartyTypeEnum, (typeof roleOptions)[number]>,
);
